export default __webpack_public_path__ + "static/media/header-confirmation.9954b2f2.jpg";